<template>
  <div class="room-chat-component">
    <div class="room-chat">
      <div class="room-chat-header">
        <div class="room-chat-setting">
          <div class="room-chat-setting-start">
            <button class="room-chat-setting-button change" 
                    @click="changeMyNickname">{{ $t("chat.changeNickname") }}</button>
          </div>
          <div class="room-chat-setting-end">
            <button class="room-chat-setting-button setting" 
                    @click="onToggleChatSetting">{{ $t("common.setting") }}</button>
            <GrmMenu class="chatSetting" text-align="left"
                :open.sync="isOpenChatSetting"
                :list="chatSettingList"
            />
          </div>
        </div>
      </div>
      <div
          class="room-chat-drag-wrapper"
          @dragenter.stop="showDragFile"
          @dragleave.stop="hideDragFile"
          @drop="dropFile"
          @dragover.prevent
          @dragenter.prevent
          @dragleave.prevent
          @drop.prevent.stop
      >
        <div class="chat-drag-file"
             v-show="activeDragFile">
          <div class="chat-drag-file-icon"></div>
          <p class="chat-drag-file-tx">
            {{ $t("chat.file.drag") }}
          </p>
        </div>
        <div class="room-chat-body" :style="dragStyle">
          <RoomNotice v-if="fixedNotice" 
                        :notice="fixedNotice"
                        :section="'chat'"
                        @onChangeNoticeSection="$emit('onChangeSection', 'notice')"/>
          <div class="overflow-y-auto h-full" ref="scroll">
            <div class="room-chat-message-list">
              <div class="chat-scroll"
                   ref="chatScroll"
              >
              </div>
              <RoomMyChat/>
              <RoomFile v-if="uploadRoomFileList"
                        :files="uploadRoomFileList"
                        :section="'chat'"
                        isUploading/>
            </div>
          </div>
        </div>
        <div v-if="isUseChat" class="room-chat-footer" :style="dragStyle">
          <div  class="room-chat-send">
            <div class="room-chat-send-header">
              <div class="room-chat-send-whisper"
                   :class="{ isOpen: isOpenWhisperList }">
                <div class="room-chat-send-whisper-header">
                  <div class="room-chat-send-whisper-input-wrapper">
                    <input  type="text" class="room-chat-send-whisper-input" :placeholder="$t('chat.whisper.placeholder')" 
                            ref="whisperSearchText" 
                            @input="searchRoomUser($event.target.value)"/>
                  </div>
                </div>
                <div class="room-chat-send-whisper-body">
                  <ul class="room-chat-send-whisper-list">
                    <li v-for="user in whisperList" :key="user.userId" class="room-chat-send-whisper-item">
                      <button class="room-chat-send-whisper-button"
                              @click="selectWhisper(user)"
                      >
                        <p class="room-chat-send-whisper-user-nickname" :class="{ selected: user.userId === whisperTarget }">{{ user.nickname }}</p>
                        <GrmMark v-if="user.roomUserRole.roleId !== 'participant'"
                                 class="ml-1 grm-mark"
                                 :data-user-role="user.roomUserRole.roleId"
                                 :data-opener="isOpener(user.userId)"
                        >{{ displayRoleName(user.roomUserRole.roleId) }}</GrmMark>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="room-chat-send-options">
                <div class="room-chat-send-option whisper">
                  <button class="room-chat-send-option-button whisper" 
                          @click="onToggleWhisperType"
                  >{{ whisperTypeText }}</button>
                  <button v-if="whisperTarget" class="room-chat-send-option-whisper"
                          @click="toggleWhisperList"
                  >{{ getUserNickname(whisperTarget) }}</button>
                  <GrmMenu class="whisperType" text-align="left"
                      :open.sync="isOpenWhisperType"
                      :list="whisperTypeList"
                  />
                </div>
                <div class="room-chat-send-option file">
                  <button v-if="hasEmceeRole() || (isParticipantRole() && useParticipantFileUpload)" class="room-chat-send-option-button file"
                          @click="handleClickUploadFile"></button>
                </div>
              </div>
            </div>
            <div class="room-chat-send-body">
              <div  class="room-chat-send-textarea-wrapper">
                <textarea class="room-chat-send-textarea" ref="inputText" :placeholder="$t('chat.placeholder')"
                          @keypress.enter="onEnter" />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="room-chat-send-footer">
          <div class="chat-input-disable">{{ $t("chat.disabled") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import store from "@/store";
import moment from "moment";
import {mapActions, mapGetters, mapMutations} from "vuex";
import GrmMenu from '@/components/Common/menu/GrmMenu'
import RoomChatForm from '@/components/Room/Chat/RoomChatForm'
import RoomMyChat from "@/components/Room/Chat/RoomMyChat";
import RoomRecord from "@/components/Room/ExtendMenu/RoomRecord/RoomRecord";
import RoomNotice from "@/components/Room/ExtendMenu/RoomNotice/RoomNotice";
import RoomFile from "@/components/Room/ExtendMenu/RoomFile/RoomFile";
import GrmMark from "@/components/Common/mark/GrmMark.vue";
import RoomUserChangeNickname from "@/components/Room/User/RoomUserChangeNickname";
import {i18n} from "@/locales/i18n";

export default {
  name: 'RoomChat',
  components: {
    GrmMark,
    GrmMenu,
    RoomNotice,
    RoomFile,
    RoomMyChat,
  },
  props: {
    newWindow: {
      type: Boolean,
      default: false,
    },
    loadChatCount: {
      type: Number,
      default: 200
    },
    extendMenuTabType: {
      type: String,
      default: 'chat'
    },
    chatHistoryProp: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpenChatSetting: false,
      isOpenWhisperType: false,
      isOpenWhisperList: false,
      fileMaxSize: 200*1024*1024,
      message: '',
      myChatIdx: 0,
      lastChat: {
        vueObj: null,
        props: null,
      },
      chatHistory: [],
      activeDragFile: false,
      whisperSearch:{
        throttle: null,
        text: '',
      },
      sttData: {}
    }
  },
  created() {
    this.$roomApi.addEventListeners((this._Events = _Events()), this)
    
    this.whisperSearch.throttle = _.throttle(
        str => {
          this.whisperSearch.text = str
        },
        1000,
        {
          leading: false, 
        })
    this.TOGGLE_SYSTEM_MESSAGE(this.roomSetting.useSystemMessage);
  },
  mounted() {
    if(this.newWindow)
      this.renderChatHistory()
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  watch: {
    isOpenWhisperList(val) {
      if(val){
        this.whisperSearch.text = '';
        setTimeout(()=>{ // TODO nextTick 으로 해결이 안 되어 임시 처리
          this.$refs.whisperSearchText.focus()
        }, 5)
      }
    },
    extendMenuTabType() {
      this.$nextTick(() => {
        this.toBottomScroll()
      });
    },
    chatHistory(){
      this.toBottomScroll();
    },
  },
  computed: {
    ...mapGetters('room', [
      'roomInfoSetting'
    ]),
    ...mapGetters('user', [
      'me',
      'isMe',
      'hasSpeaker',
      'getRoomUser',
      'getUsername',
      'hasEmceeRole',
      'roomUserListExceptMe',
      'isObserverRole',
      'isOpener',
      'isParticipantRole',
      'roomUserListSpeaker',
      'roomUserListEmcee'
    ]),
    ...mapGetters('notice', [
      'fixedNotice',
    ]),
    ...mapGetters('file',[
      'uploadRoomFileList',
    ]),
    ...mapGetters('chat',[
      'chatNotification',
      'systemMessage',
      'whisperType',
      'whisperTarget',
    ]),
    ...mapGetters('roomSetting',['roomSetting']),
    ...mapGetters('meetingNote', [
      'isOngoingMeetingNote',
    ]),
    isWhisperAll() {
      return this.whisperType === 'all'
    },
    isWhisperStaff() {
      return this.whisperType === 'staff'
    },
    isWhisper() {
      return this.whisperType === 'whisper'
    },
    whisperTypeText() {
      switch (this.whisperType) {
        case 'all':
          return this.$t('chat.whisper.target.all')
        case 'staff':
          return this.$t('chat.whisper.target.staff')
        default:
          return this.$t('chat.whisper.target.default')
      }
    },
    useChatTargetOnlySpeaker() {
      return this.roomInfoSetting?.['useChatTargetOnlySpeaker'];
    },
    useChatTargetOnlyStaff() {
      return this.roomInfoSetting?.['useChatTargetOnlyStaff'];
    },
    whisperTypeList() {
      if (this.isParticipantRole()) {
        if (this.useChatTargetOnlySpeaker) {
          return [
            {
              title: this.$t('chat.whisper.target.default'),
              selected: () => {
                return this.isWhisper && !this.isOpenWhisperList
              },
              click: () => {
                this.isOpenWhisperList = false
              }
            },
          ];
        }
        if (this.useChatTargetOnlyStaff) {
          return [
            {
              title: this.$t('chat.whisper.target.staff'),
              selected: () => {
                return this.isWhisperStaff && !this.isOpenWhisperList
              },
              click: () => {
                this.setWhisperTarget({target:'staff'});
                this.isOpenWhisperList = false
              }
            },
          ];
        }
      }
      return [
        {
          title: this.$t('chat.whisper.target.all'),
          selected: () => {
            return this.isWhisperAll && !this.isOpenWhisperList
          },
          click: () => {
            this.setWhisperTarget({target: 'all'});
            this.isOpenWhisperList = false;
          }
        },
        {
          title: this.$t('chat.whisper.target.staff'),
          selected: () => {
            return this.isWhisperStaff && !this.isOpenWhisperList
          },
          click: () => {
            this.setWhisperTarget({target:'staff'});
            this.isOpenWhisperList = false
          }
        },
        {
          title: this.$t('chat.whisper.target.default'),
          selected: () => {
            return this.isWhisper || this.isOpenWhisperList
          },
          click: () => {
            this.isOpenWhisperList = true
          }
        },
      ];
    },
    getSimpleDateForm() {
      return date => {
        return moment(date).format('HH:mm');
      }
    },
    receiveDate(){
      return date => {
        return (
            this.getSimpleDateForm(date)
        )
      }
    },
    dragStyle() {
      return {
        pointerEvents: this.activeDragFile ? 'none' : 'initial',
      }
    },
    roomUserNickname: function() {
      return userId => {
        let ru = this.getRoomUser(userId);
        if(!ru){
          return this.$t('common.leavedUser') // TODO 처리 필요
        }
        return ru.nickname.escapeXml();
      }
    },
    getUserNickname() {
      return userId => {
        if (!userId) {
          return ''
        }
        return this.getRoomUser(userId)?.nickname.escapeXml()
      };
    },
    whisperList() {
      if (this.isParticipantRole()) {
        if (this.useChatTargetOnlySpeaker) {
          return this.roomUserListSpeaker;
        }
        if (this.useChatTargetOnlyStaff) {
          return this.roomUserListEmcee;
        }
      }
      if(this.whisperSearch.text){
        return this.roomUserListExceptMe.filter(user => user.nickname?.includes(this.whisperSearch.text));
      } else{
        return this.roomUserListExceptMe;
      }
    },
    isChatMenuTab(){
      return this.extendMenuTabType == 'chat'
    },
    isUseChat(){
      if(!this.me) return;
      return this.hasEmceeRole() || (this.roomSetting && this.roomSetting['useChat'])
    },
    displayRoleName() {
      return roleId => {
        switch (roleId) {
          case 'speaker': return this.$t('common.speaker');
          case 'emcee': return this.$t('common.emcee');
          case 'participant': return this.$t('common.participant');
          default: return 'UNKNOWN';
        }
      }
    },
    chatSettingList(){
      return [
        {
          title: this.$t('chat.notice'),
          toggleStatus: () => {
            return this.chatNotification
          },
          click: () => {
            this.TOGGLE_CHAT_NOTIFICATION()
          }
        },
        {
          title: this.$t('chat.systemMessage'),
          toggleStatus: () => {
            return this.systemMessage
          },
          click: () => {
            this.TOGGLE_SYSTEM_MESSAGE(!this.systemMessage);
          }
        },
        {
          title: this.$t('chat.save'),
          click: () => {
            this.downloadChatList()
          }
        },
      ]
    },
    useParticipantFileUpload() {
      return this.roomInfoSetting?.['useParticipantFileUpload'];
    },
  },
  methods: {
    ...mapActions('chat', [
        'sendChatMessage',
        'sendChatEmoticon',
        'getChatsHistoryList',
        'setWhisperTarget',
    ]),
    ...mapActions('translation', ['getTranslationUse']),
    ...mapMutations('chat',[
      'REMOVE_MY_CHAT',
      'TOGGLE_CHAT_NOTIFICATION',
      'TOGGLE_SYSTEM_MESSAGE',
    ]),
    ...mapMutations('record',[
      'ADD_RECORD_FILE_INSTANCE'
    ]),
    ...mapActions('file', [
      'uploadRoomFile',
    ]),
    ...mapActions('notice', [
      'deleteNotice',
      'setNoticeFix',
    ]),
    ...mapMutations('notice', [
      'ADD_NOTICE',
      'DELETE_NOTICE',
      'SET_NOTICE_FIX',
    ]),
    changeMyNickname() {
      this.$modal(RoomUserChangeNickname, {
        data: {
          user: this.me,
        },
      })
    },
    onToggleChatSetting() {
      this.isOpenChatSetting = !this.isOpenChatSetting
    },
    onToggleWhisperType() {
      if (this.isParticipantRole() && (this.useChatTargetOnlySpeaker || this.useChatTargetOnlyStaff)) {
        return;
      }
      this.isOpenWhisperType = !this.isOpenWhisperType;
    },
    onEnter(e) {
      if (e.shiftKey) {
        return
      }
      e.preventDefault()

      const target = e.target
      const text = target.value.trim()
      if (!text.length) {
        return;
      }

      if (
          this.useChatTargetOnlySpeaker &&
          this.isParticipantRole() &&
          !this.whisperTarget
      ) {
        this.$alert(this.$t('chat.notFoundUser'), () => {
          this.$refs.inputText.focus();
        })
        return;
      }

      let data = {
        text,
        myChatIdx: this.myChatIdx,
        target: this.whisperType,
        toUserId: this.whisperTarget,
        toUserIds: this.isWhisperStaff && this.roomUserListEmcee ? this.roomUserListEmcee.map(ru => {return ru.userId}) : []
      }
      this.sendChatMessage(data);
      target.value = '';
      
      this.myChatIdx++;
    },
    async downloadChatList() {
      const msgList = await this.getChatsHistoryList();
      const messages = msgList.map(msg => `${this.formatTime(msg.eventTime)} - ${msg.roomUser.nickname} -> ${msg.data.target} \t : ${msg.data.text}\n`)
      const blob = new Blob(messages, {type: 'text/plain', endings: 'native'});
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      try{
        a.href = url;
        a.download = `${this.$t('chat.file.save')}.txt`;
        document.body.append(a);
        a.click();
      }finally{
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    },

    async renderChatHistory(){
      if(this.chatHistoryProp.length < 1)
        return;
      
      this.chatHistoryProp.forEach(vueData=>{
        const chatNode = document.createElement('div');
        const chatContainer = this.$refs.chatScroll;
        chatContainer.appendChild(chatNode);

        if(vueData.props.type === 'chat'){
          this.lastChat.vueObj = {};
          vueData = _.cloneDeep(vueData)
          Vue.observable(vueData)
          this.lastChat.item = vueData.props.item;
        }

        const instance = this.createNewVueInstance(vueData).$mount(chatNode);
        if (vueData.props?.record?.recordId) {
          this.ADD_RECORD_FILE_INSTANCE({
            recordId: vueData.props.record.recordId,
            instance: [chatNode, instance],
          })
        }
      })
      this.toBottomScroll();
    },
    
    addMyChat(text) {
      this.appendMessage({
        text,
        isMine: true,
        userId: this.me.userId,
        target: this.whisperType,
        toUserId: this.whisperTarget,
      });
    },

    formatTime(time) {
      return time.replace('T', '  ').slice(0, 20);
    },
    // translatedTextReceiveChat(e){
    //   console.log("### e: ", e)
    //   if(!this.lastChat.item.translatedText){
    //     this.lastChat.item.translatedText = "";
    //   }
    //   this.lastChat.item.translatedText = this.lastChat.item.translatedText.concat(e.data.translateData.translatedText)
    //   console.log("### this.lastChat", this.lastChat)
    // },
    receiveChat(e, type = 'chat') {
      if (!e.data.target) {
        e.data.target = 'all';
      }

      if(type === 'translate'){
        const sttData = this.sttData[e.data.syncTranslationUUID];
        this.addChat({...sttData, translatedText: e.data.translateData.translatedText})
        delete this.sttData[e.data.syncTranslationUUID]
        return;
      }

      let chatData = {
        type,
        ...e.data,
        userId: e.userId,
        date: e.eventTime,
      }

      this.addChat(chatData);
    },
    addChat(chatData) {
      const {userId} = chatData;

      if (!userId) {
        return;
      }

      this._throttle_addChat_list = this._throttle_addChat_list || [];
      this._throttle_addChat_list.push({
        ...chatData,
        userId,
      });

      const throttle_term = 300;
      if(this._throttle_run){
        return;
      }
      this._addChat_throttle();
      this._throttle_run = setInterval(() => {
        if(this._throttle_addChat_list.length === 0){
          this._throttle_run_loop++;
          if(this._throttle_run_loop > 3){
            clearInterval(this._throttle_run);
            this._throttle_run = null;
          }
          return;
        }
        this._throttle_run_loop = 0;
        this._addChat_throttle();
      }, throttle_term);
    },
    _addChat_throttle() {
      let job;
      while(
          (job=this._throttle_addChat_list.shift()) != null
          ){
        try{
          this.appendMessage({
            ...job
          });
        }catch(e){
          console.error(e);
        }
      }
    },

    appendMessage(messageData) {
      const chatContainer = this.$refs.chatScroll;
      let append = () => {
        if(messageData._type_ === 'html'){
          let {chatForm} = messageData;
          if(!chatForm){
            let {roomUser, target, mentionList, text} = messageData;
            chatForm = `
              <div class="user-chat">
                <div class="">
                  <img
                    src=""
                    class="profile-img"
                  >
                </div>
                <div class="chat-text-wrapper">
                  <div class="chat-name">${roomUser.nickname.escapeXml()}</div>
                  <div class="chat-txt">
                    ${target==='staff' ? `<div class="chat-to">${this.$t('chat.snapchat')}</div>` : ''}
                    <span class="chat-mention">${mentionList}</span>
                    ${text}
                  </div>
                </div>
              </div>`;
          }

          chatContainer.insertAdjacentHTML('beforeend', chatForm);
        }else{
          if(messageData.type === 'chat' && this.me.userId === messageData.userId){
            this.REMOVE_MY_CHAT(messageData);
          }
          {
            const {date, text, userId, toUserId, type, translatedText} = messageData;
            const receiveDate = this.receiveDate(date);
            
            if (!this.lastChat.vueObj 
                || this.lastChat.item?.type != type
                || this.lastChat.item?.userId != userId
                || this.lastChat.item?.receiveDate != receiveDate
                || this.lastChat.item?.toUserId != toUserId) {
              
              const chatNode = chatContainer.appendChild(document.createElement('div'));
              messageData.receiveDate = receiveDate;
              messageData.nickname = this.roomUserNickname(userId);
              if (toUserId) {
                messageData.receiveUser = this.roomUserNickname(toUserId);
              }

              if (messageData.target === 'staff') {
                messageData.receiveUser = this.$t('chat.whisper.target.staff')
              }
              
              this.lastChat.item = Vue.observable(messageData);
              let vueData = {
                component: RoomChatForm,
                props: {
                  type: type,
                  item: this.lastChat.item,
                },
              };
              
              this.lastChat.vueObj = this.createNewVueInstance(vueData).$mount(chatNode);
              this.chatHistory.push(vueData)
            } else {
              this.lastChat.item.text += `\r${text}`;
              if(translatedText !== undefined) {
                this.lastChat.item.translatedText = (this.lastChat.item.translatedText || "")+`\r${translatedText}`;
              }
            }
          }
        }

        const limit = 500;
        const gcCnt = chatContainer.childElementCount - limit;
        if(gcCnt > 0){
          for(let i=0; i<gcCnt; i++){
            chatContainer.firstElementChild.remove();
          }
        }
        this.$nextTick(() => {
          this.toBottomScroll()
        });
      }

      if(chatContainer){
        append();
      }else{
        this.$nextTick(() => {
          append();
        });
      }
    },
    toBottomScroll(){
      if(this.isChatMenuTab){
        const scroll = this.$refs.scroll
        scroll.scrollTop = 999999;//scroll.scrollHeight;
      }
    },

    chatMessage() {
      if (!this.message && !this.mentionList.length) {
        return;
      }

      const textData = this.message;
      const mentionList = this.mentionList.map(m => m.userId);

      this.sendChatMessage({
        target: this.whisperTarget,
        text: textData,
        mentionList,
        unreliable: true,
        myChatIdx: this.myChatIdx,
      });

      this.myChatIdx++;

      this.mentionList = [];
      this.message = '';
      this.$refs.inputText.focus();
    },
    toggleWhisperList() {
      this.isOpenWhisperList = !this.isOpenWhisperList;
    },
    selectWhisper(user) {
      this.setWhisperTarget({target:'whisper', userId: user});
      this.toggleWhisperList()
      this.$refs.inputText.focus()
    },
    async handleClickUploadFile(e) {
      if (!this.hasEmceeRole() && !this.roomSetting.useParticipantFileUpload) {
        this.$alert({
          text: this.$t('chat.file.noPermission', { '0' : this.displayRoleName(this.me.roomUserRole.roleId) }),
          onlyOk: true,
        });
        return;
      }

      const files = await this.getFileChooser({
          multiple: false,
          accept: this.allowedFileExts,
          size: 1
      });
      if(files.length === 0)
          return;

      try {
          for(let el of files){
              if(el.size > this.fileMaxSize){
                  throw {message: `Maximum upload size of ${this.fileMaxSize} bytes exceeded`};
              }
          }
          await this.uploadRoomFile(files);
      } catch (e) {
          this.fileUploadFailed(e);
      }
    },
    showDragFile(e){
      if (!this.hasEmceeRole() && !this.roomSetting.useParticipantFileUpload) {
        this.$alert({
          text: this.$t('chat.file.noPermission', { '0' : this.displayRoleName(this.me.roomUserRole.roleId) }),
          onlyOk: true,
        });
        return;
      }
      this.activeDragFile = true;
    },
    hideDragFile(e){      
      if (e.target.classList.contains('room-chat-drag-wrapper')) {
        this.activeDragFile = false;
      }
    },
    async dropFile(e){
      if (!this.hasEmceeRole() && !this.roomSetting.useParticipantFileUpload) {
        this.activeDragFile = false;
        this.$alert({
          text: this.$t('chat.file.noPermission', { '0' : this.displayRoleName(this.me.roomUserRole.roleId) }),
          onlyOk: true,
        });
      }
      this.activeDragFile = false;
      let files = e.dataTransfer.files;
      try {
        if (files.length > 0) {
          for(let el of files){
            if(el.size > this.fileMaxSize){
              throw {message: `Maximum upload size of ${this.fileMaxSize} bytes exceeded`};
            }
          }

          await this.uploadRoomFile(files);
          this.$nextTick(() => {
            this.toBottomScroll()
          });
        }
      } catch (e) {
        this.fileUploadFailed(e);
      }
    },
    fileUploadFailed (e){
      console.warn(e)
      try{
        if(e.message?.includes('Maximum upload size of ')){
          const regex = /[^0-9]/g;
          const result = e.message.replace(regex, "");

          e = `파일 용량은 ${result/1024/1024}MB를 초과할 수 없습니다.`;
        }
      }catch (e) {
        console.warn(e)
      }
      this.$alert({
        text: this.$t('chat.file.uploadFail', { '0' : e }),
        onlyOk: true,
      });
    },
    roomUserLog(e){
      if(!this.systemMessage) return;
      const roomUser = e.data?.roomUser;
      if(!roomUser || !this.me.userId || roomUser == this.me)
        return;
      
      const chatNode = document.createElement('div');
      const chatContainer = this.$refs.chatScroll;
      chatContainer.appendChild(chatNode);
      
      
      let msg;
      const type = e.type;
      if(type == 'room_user_enter'){
        msg = this.$t('chat.join');
      } else if(type == 'room_user_leave'){
        const isKicked = e.data.reason == 'kick';
        if(isKicked && this.hasEmceeRole())
          msg = this.$t('chat.ban');
        else 
          msg = this.$t('chat.leave');
      }
      const content = `${roomUser.nickname}님이 ${msg}`;
      const date = this.receiveDate(e.eventTime);
      let vueData = {
        component: RoomChatForm,
        props: {
          section: 'chat',
          type: 'systemMsg',
          item: {
            date,
            content,
          },
        },
      };

      this.createNewVueInstance(vueData).$mount(chatNode);
      this.chatHistory.push(vueData);
    },
    searchRoomUser(str) {
      if (!str) {
        this.whisperSearch.throttle.cancel()
        this.whisperSearch.text = '';
      }else{
        this.whisperSearch.throttle(str)
      }
    },
    changeUserRoleIdLog(e) {
      if (!this.systemMessage) {
        return;
      }

      const { roleId, userId } = e.data;
      const roomUser = this.getRoomUser(userId);
      if(!roomUser || !this.me.userId) {
        return;
      }

      const chatNode = document.createElement('div');
      const chatContainer = this.$refs.chatScroll;
      chatContainer.appendChild(chatNode);

      const content = this.$t('chat.roleChanged', { '0' : roomUser.nickname, '1' : this.displayRoleName(roleId) });
      const date = this.receiveDate(e.eventTime);

      let vueData = {
        component: RoomChatForm,
        props: {
          section: 'chat',
          type: 'systemMsg',
          item: {
            date,
            content,
          },
        },
      };

      this.createNewVueInstance(vueData).$mount(chatNode);
      this.chatHistory.push(vueData);
    },
    removeRecordChatHistory({ recordId }){
      this.chatHistory = this.chatHistory.filter((el) => el.props.record?.recordId != recordId);
    },
    createNewVueInstance({component, props}){
      return new Vue({
        i18n,
        store,
        render: h => h(component, {
          props
        }),
      })
    },
    _setWhisperTarget() {
      if (this.isParticipantRole()) {
        let target = 'all';
        if (this.useChatTargetOnlySpeaker) {
          target = 'whisper';
        }
        if (this.useChatTargetOnlyStaff) {
          target = 'staff';
        }
        const speakerUser = this.roomUserListSpeaker?.[0];
        this.setWhisperTarget({target: target, userId: speakerUser ? speakerUser.userId : ''});
      }
    }
  }
}

function _Events() {
  return {
    // add_my_chat: function (e) {
    //   this.addMyChat(e.text);
    // },
    room_file_add: function (e) {
      let file = e.data?.roomFile;
      if(!file)
        return;

      const chatContainer = this.$refs.chatScroll;
      const chatNode = document.createElement('div');
      chatContainer.appendChild(chatNode);
      
      let vueData = {
        component: RoomFile,
        props: {
          section: 'chat',
          files: [file],
        },
      };

      this.createNewVueInstance(vueData).$mount(chatNode);
      this.chatHistory.push(vueData)
    },
    room_chat_text: function (e) {
      this.receiveChat(e, 'chat');
    },
    room_user_recordFileSaved: function (e) {
      let record = e.data?.record;
      if(!record)
        return;
      
      const chatContainer = this.$refs.chatScroll;
      const chatNode = document.createElement('div');
      chatContainer.appendChild(chatNode);

      let vueData = {
        component: RoomRecord,
        props: {
          section: 'chat',
          record: record
        },
      };

      const recordFileInstance = this.createNewVueInstance(vueData)
      recordFileInstance.$mount(chatNode);
      this.chatHistory.push(vueData);

      this.ADD_RECORD_FILE_INSTANCE({
        recordId: record.recordId,
        instance: [chatNode, recordFileInstance]
      })
    },
    room_user_enter: function (e) {
      this.roomUserLog(e)
      this._setWhisperTarget();
    },
    room_user_leave: function (e) {
      this.roomUserLog(e)
      this._setWhisperTarget();
    },
    room_changeUserRoleId: function (e) {
      this.changeUserRoleIdLog(e);
      this._setWhisperTarget();
    },
    publish_stt_result: async function (e) {
      const {data: {final, text}, userId} = e;
      if(!final) return;


      if(this.isOngoingMeetingNote) {
        const data = await this.getTranslationUse()
        if(!data){
          this.receiveChat(e, 'stt')
          return;
        }
        this.sttData = {
          [e.data.syncTranslationUUID]: {
            type: "stt",
            ...e.data,
            userId: e.userId,
            date: e.eventTime,
          }
        }
      }
    },
    add_translation_text: function (e) {
      if(this.isOngoingMeetingNote) {
        this.receiveChat(e, 'translate')
      }
    },
    room_data_init: function (e) {
      this._setWhisperTarget();
    }
  }
}
</script>

<style lang="scss" scoped>
.room-chat-component {}
.room-chat {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.room-chat-header {
  height: 40px;
  border-bottom: 1px solid #d4d4d4;
  background-color: #f8f8f8;
}
.room-chat-setting {
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.room-chat-setting-start {}
.room-chat-setting-button {
  height: 100%;
  padding: 0 14px 0 30px;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  &.change {
    background: url('~@/assets/images/write.svg') no-repeat center left 10px / 12px auto;
  }
  &.setting {
    background: url('~@/assets/images/setting_line_gray.svg') no-repeat center left 10px / 14px auto;
  }
}
.room-chat-setting-end {
  position: relative;
}
.room-chat-drag-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.room-chat-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.room-chat-message-list {
  height: 100%;
}
.room-chat-footer {
  height: 150px;
}
.room-chat-send {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.room-chat-send-header {
  height: 46px;
  position: relative;
}
.room-chat-send-options {
  height: 100%;
  border-top: 1px solid #c8c8c8;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.room-chat-send-option {
  display: flex;
  position: relative;
  &.whisper {
    min-width: 0;
    flex: 1;
  }
  &.file {}
}
.room-chat-send-option-button {
  height: 100%;
  &.whisper {
    padding: 0 24px 0 12px;
    background: url('~@/assets/images/arrow_down_triangular_filled.svg') no-repeat center right 10px / 6px auto;
    font-size: 12px;
  }
  &.file {
    width: 32px;
    background: url('~@/assets/images/clip.svg') no-repeat center / 8px auto;
  }
}
.room-chat-send-option-whisper {
  flex: 1;
  min-width: 0;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 500;
  color: #59f;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:before {
    content: "";
    width: 1px;
    height: 18px;
    background: #e8e8e8;
    position: absolute;
    top: 14px;
    left: 0;
  }
}
.room-chat-send-whisper {
  background-color: #fff;
  box-shadow: 4px 10px 30px rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  transform: translateY(0);
  visibility: hidden;
  transition: 0.2s ease-out;
  &.isOpen {
    transform: translateY(-100%);
    visibility: visible;
  }
}
.room-chat-send-whisper-header {
  height: 60px;
  padding: 12px 16px;
}
.room-chat-send-whisper-input-wrapper {}
.room-chat-send-whisper-input {
  width: 100%;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 0 12px 0 30px;
  background: #f9f9f9 url("~@/assets/images/search.svg") no-repeat center left 12px / 11px auto;
  font-size: 12px;
  line-height: 34px;
}
.room-chat-send-whisper-body {}
.room-chat-send-whisper-list {
  max-height: 160px;
  padding-bottom: 8px;
  overflow-y: auto;
}
.room-chat-send-whisper-item {}
.room-chat-send-whisper-button {
  width: 100%;
  padding: 0 16px;
  display: flex;
  align-items: center;
  transition: 0.2s ease-out;
  &:hover {
    background-color: #ececec;
  }
}
.room-chat-send-whisper-user-nickname {
  flex: 1;
  min-width: 0;
  max-width: max-content;
  font-size: 12px;
  color: #666;
  line-height: 34px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.selected {
    padding-left: 20px;
    background: url('~@/assets/images/check_blue.svg') no-repeat center left / 11px;
    font-weight: 500;
    color: #59f;
  }
}
.room-chat-send-body {
  flex: 1;
  border-top: 1px solid #eee;
  padding: 12px;
  background-color: #fff;
  position: relative;
}
.room-chat-send-textarea-wrapper {
  height: 100%;
}
.room-chat-send-textarea {
  width: 100%;
  height: 100%;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 0 12px 0 6px;
  font-size: 13px;
  line-height: 22px;
  resize: none;
  transition: 0.1s ease-out;
  &:focus {
    border-color: $mainColor;
  }
}
.chat-drag-file{
  display: flex;
  position: absolute;
  box-sizing: border-box;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(230, 240, 255, 0.94);
  border: 1px dashed #59f;
  z-index: 9;
  pointer-events: none;

  .chat-drag-file-icon {
    width: 56px;
    height: 56px;
    background: url('~@/assets/images/upload_blue.svg') center no-repeat;
    background-size: 100%;
  }
  .chat-drag-file-tx {
    margin-top: 20px;
    font-size: 15px;
    color: #59f;
  }
}
.room-chat-send-footer {}

.grm-menu-component {
  position: absolute;
  top: 30px;
  &.chatSetting {
    min-width: 160px;
    right: 10px;
  }
  &.whisperType {
    left: 10px;
  }
}
.chat-input-disable {
  width: 100%;
  border-top: 1px solid #ddd;
  padding: 0 16px;
  background-color: #eee;
  font-size: 13px;
  color: #999;
  line-height: 44px;
}
.grm-mark{
  &[data-user-role="speaker"]{
    background-color: #fa5;
  }
  &[data-user-role="emcee"]{
    background-color: #bfbfc4;
  }
}
</style>